import { Coordinate } from "./route-data";
import { roundToDecimal } from "./types";

let latestGeoLocation: ParsedGeoLocation|undefined = undefined;

// If the location was available in history.state and is not too old,
// call this so that the location gets used.
export function setInitialCachedLocation(location: ParsedGeoLocation) {
  latestGeoLocation = location;
}

export interface ParsedGeoLocation {
  coord: Coordinate,
  // Unix-epoch milliseconds
  lastUpdated: number,
  accuracy: string,
}

export function parseGeoLocation(pos: GeolocationPosition): ParsedGeoLocation {
  return {
    coord: {lat: pos.coords.latitude, lon: pos.coords.longitude},
    lastUpdated: new Date(pos.timestamp).getTime(),
    accuracy: roundToDecimal(pos.coords.accuracy),
  }
}

export function requestGeoLocation(onSuccess: (loc: ParsedGeoLocation) => void, onError: () => void) {
  navigator.geolocation.getCurrentPosition(
    (pos) => {
      latestGeoLocation = parseGeoLocation(pos);
      onSuccess(latestGeoLocation);
    },
    onError,
    {enableHighAccuracy: true});
}

export function getLatestGeoLocation(): ParsedGeoLocation|undefined {
  return latestGeoLocation;
}